export default __webpack_public_path__ + "static/media/Mail.353ce3b6.svg";